export default __webpack_public_path__ + "static/boat-11f99267a0cab4ad5ae8a15a71ec276e.png";